export default {
  title: {
    id: 'live_shopping_widget_title',
    defaultMessage: 'Live shopping',
  },
  tagLabel: {
    id: 'live_shopping_widget_tag_label',
    defaultMessage: 'Live shopping',
  },
  productCountIpad: {
    id: 'live_shopping_widget_product_count_ipad',
    defaultMessage: '{count} iPads',
  },
  productCountMacbook: {
    id: 'live_shopping_widget_product_count_macbook',
    defaultMessage: '{count} MacBooks',
  },
  errorMessage: {
    id: 'live_shopping_widget_error_message',
    defaultMessage: "We couldn't load the featured products. Please try again.",
  },
  expandLabel: {
    id: 'live_shopping_widget_expand_label',
    defaultMessage: 'Expand',
  },
  closeLabel: {
    id: 'live_shopping_widget_close_label',
    defaultMessage: 'Close',
  },
  minimizeLabel: {
    id: 'live_shopping_widget_minimize_label',
    defaultMessage: 'Minimize',
  },
  dismissLabel: {
    id: 'live_shopping_widget_dismiss_label',
    defaultMessage: 'Dismiss',
  },
}
